import React, { useMemo, useRef, useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { FilterOutlined, UndoOutlined } from "@ant-design/icons";
import moment from "moment";

const GeneralProcurementList = () => {
  const navigate = useNavigate();
  const formRef = useRef();

  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [state, setState] = useState({
    page: 1,
    pagesize: 10,
    ordering: "id",
    search: "",
  });

  const handleStartDateChange = (date) => {
    setStartDate(date ? moment(date).format("DD-MM-YY") : "");
  };

  const handleEndDateChange = (date) => {
    setEndDate(date ? moment(date).format("DD-MM-YY") : "");
  };

  const handleApplyFilter = () => {
    setClickedFilterButton(true);
    setState((prev) => ({
      ...prev,
      page: 1,
      pr_created_date__gte: startDate,
      pr_created_date__lte: endDate,
    }));
  };

  const handleClearFields = () => {
    setStartDate("");
    setEndDate("");
    formRef.current?.setFieldsValue({
      pr_created_date__gte: null,
      pr_created_date__lte: null,
    });
  };

  const handleReset = () => {
    setClickedFilterButton(false);
    setStartDate("");
    setEndDate("");
    setState({
      page: 1,
      pagesize: 10,
      ordering: "id",
      search: "",
    });
    formRef.current?.resetFields();
  };

  const { Search } = Input;
  const onSearch = (value) => {
    setState((prev) => ({
      ...prev,
      page: 1,
      search: value || "",
    }));
  };

  // Placeholder table until API wiring is added
  const columns = useMemo(
    () => [
      {
        title: "PR Number",
        dataIndex: "pr_number",
        key: "pr_number",
      },
      {
        title: "PR Created Date",
        dataIndex: "pr_created_date",
        key: "pr_created_date",
      },
      {
        title: "PR Status",
        dataIndex: "pr_status",
        key: "pr_status",
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 120,
        render: () => null,
      },
    ],
    []
  );

  const dataSource = useMemo(() => [], []);

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>General Procurement (PR) - History</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>General Procurement (PR) - History</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Space>
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label="Add New PR"
              onClick={() => navigate("/general-procurement/add")}
            />
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="pr_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select Start Date"
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="pr_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select End Date"
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>

                  <Button
                    type="primary"
                    htmlType="button"
                    icon={
                      <Tooltip title="Apply" color="#094E8F">
                        <FilterOutlined style={{ fontSize: "20px" }} />
                      </Tooltip>
                    }
                    style={{
                      backgroundColor: "#094e8f",
                      color: "#ffffff",
                      border: "none",
                      width: "40px",
                      height: "40px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                    }}
                    onClick={startDate || endDate ? handleApplyFilter : null}
                  />
                  <Button
                    type="primary"
                    htmlType="button"
                    icon={
                      <Tooltip title="Reset" color="#094E8F">
                        <UndoOutlined style={{ fontSize: "20px" }} />
                      </Tooltip>
                    }
                    style={{
                      backgroundColor: "#094e8f",
                      color: "#ffffff",
                      border: "none",
                      width: "40px",
                      height: "40px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                    }}
                    onClick={clickedFilterButton ? handleReset : handleClearFields}
                  />
                </Space>
              </Form>
            </div>

            <div className="btnscol">
              <Space>
                <div className="searchwrp">
                  <Space direction="vertical">
                    <Search
                      placeholder="Search"
                      onSearch={onSearch}
                      allowClear
                      style={{ width: 250 }}
                      value={state.search}
                      onChange={(e) => onSearch(e.target.value)}
                    />
                  </Space>
                </div>
              </Space>
            </div>
          </div>

          <div className="tablewrp">
            <Table
              scroll={{ x: 900 }}
              columns={columns}
              dataSource={dataSource}
              rowKey={(record) => record.id || record.pr_number || JSON.stringify(record)}
              pagination={{
                current: state.page,
                pageSize: state.pagesize,
                showSizeChanger: true,
                locale: { items_per_page: "Items / Page" },
              }}
              onChange={(pagination) => {
                setState((prev) => ({
                  ...prev,
                  page: pagination.current,
                  pagesize: pagination.pageSize,
                }));
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default GeneralProcurementList;